{
	"404": {
		"go-to-home-screen": "Ir a la pantalla de inicio",
		"this-screen-doesnt-exist": "Esta pantalla no existe"
	},
	"add-image": {
		"permission-to-access-camera-roll-is-required": "¡Se requiere permiso para acceder al álbum de la cámara!",
		"record-video": "Grabar un video",
		"select-photo-from-gallery": "Seleccionar una foto de la galería",
		"take-photo": "Tomar una foto"
	},
	"common": {
		"add": "Añadir",
		"back": "Atrás",
		"cancel": "Cancelar",
		"create": "Crear",
		"delete": "Eliminar",
		"done": "Listo",
		"e-mail": "Correo electrónico",
		"edit": "Editar",
		"get-started": "Comenzar",
		"language": "Idioma",
		"more": "Más",
		"next": "Siguiente",
		"no": "No",
		"optional": "Opcional",
		"or": "O",
		"password": "Contraseña",
		"password-requirements-hint": "Mín. {{minLength}} caracteres, un número, un carácter especial",
		"read-more": "Leer más",
		"save": "Guardar",
		"saving": "Guardando",
		"search": "Buscar",
		"select": "Seleccionar",
		"select-all": "Seleccionar todo",
		"selected": "Seleccionado",
		"selected-all": "Todo seleccionado",
		"send": "Enviar",
		"show-less": "Mostrar menos",
		"sign-out": "Cerrar sesión",
		"skip": "Omitir",
		"steps-of-total": "{{completed}} de {{total}}",
		"view-all": "Ver todo",
		"yes": "Sí",
		"beta": "beta",
		"block": "Bloquear",
		"ok": "De acuerdo"
	},
	"connections": {
		"add-connection": "Añadir conexión",
		"add-friends-to-view-post": "Pletly es más divertido con otros usuarios. Descubre si algunos de los tuyos ya se han unido o crea otros nuevos.",
		"add-information": "Añadir información",
		"are-you-sure-you-want-delete-group": "¿Estás seguro de que deseas eliminar el grupo {{name}}?",
		"are-you-sure-you-want-remove-from-group": "¿Estás seguro de que deseas eliminar a {{name}} de este grupo?",
		"are-you-sure-you-want-to-remove-name-from-connections": "¿Estás seguro de que deseas eliminar a {{name}} de tu lista de conexiones?",
		"bravo-you-managed-create-account": "¡Bravo! Has logrado crear una cuenta para {{name}}",
		"cancel-invitation": "¿Cancelar invitación?",
		"choose-how-you-want-to-connect-care-receiver": "Elige cómo quieres conectarte con un cliente de cuidado. Puedes crear una nueva cuenta o conectarte a una existente.",
		"connect": "Conectar",
		"connect-new-care-receiver": "Conectar un nuevo cliente de cuidado",
		"connect-to-care-receiver": "Conectarme con un cliente de cuidado",
		"connection-request-successfully-sent": "Solicitud de conexión enviada con éxito",
		"connections": "Conexiones",
		"create-account-for-care-recipient": "Crear cuenta para un receptor de cuidado",
		"create-another-care-recipient": "Crear otro cliente de cuidado",
		"create-care-receiver": "Crear un cliente de cuidado",
		"create-care-receiver-account": "Crear una cuenta para el cliente de cuidado",
		"create-group": "Crear un grupo",
		"created-account-successfully-for": "Has creado exitosamente una cuenta para {{name}}",
		"delete-group": "Eliminar grupo",
		"do-you-want-to-fill-information": "¿Te gustaría agregar información adicional sobre tu receptor de cuidado para ayudar a otros cuidadores?",
		"edit-group-name": "Editar nombre del grupo",
		"enter-emails-of-caregivers-you-want-connect": "Introduce los correos electrónicos de los cuidadores que deseas conectar con {{name}}",
		"enter-the-information-about-user-to-bind-account-to-pletly-pal": "Ingresa la información sobre el usuario para vincular la cuenta a Pletly Pal",
		"enter-the-information-about-user-to-create-account-in-pletly-pal": "Ingresa la información solicitada para crear una cuenta para el cliente de cuidado. Se le asignará como propietario de la cuenta creada.",
		"invitations-to-become-caregiver": "Invitaciones para convertirse en cuidador",
		"invitations-to-connect": "Invitaciones para conectarse",
		"invite-caregivers": "Invitar cuidadores",
		"invite-others-to-connect-with": "Invitar a otros a conectarse con {{name}}",
		"invites-of-your-proteges": "Invitaciones de tu cliente de cuidado",
		"my-connections": "Mis conexiones",
		"name-group": "Nombre del grupo",
		"new-invitation": "Nueva invitación",
		"new-request": "Nueva solicitud",
		"oops-kinda-quiet-here": "¡Vaya! Aquí está un poco tranquilo",
		"oops-look-like-you-dont-have-any-connections": "¡Oops! Parece que no tienes ninguna conexión.",
		"remove-name": "Eliminar a {{name}}",
		"remove-user": "Eliminar usuario",
		"send-invitations": "Enviar invitaciones",
		"sent-invites": "Invitaciones enviadas",
		"tab-groups": "Grupos",
		"tab-users": "Usuarios",
		"to-be-able-to-use-pletly-pal-as-intended-and-see-resourcename-you-have-to-be-connected-to-one-or-more-users": "Para poder utilizar Pletly Pal según lo previsto y ver {{resourceName}}, debes estar conectado a uno o más usuarios",
		"users-count_one": "{{count}} usuario",
		"users-count_other": "{{count}} usuarios",
		"who-sent-invite": "{{who}} envió la invitación",
		"you-can-invite-others-to-connect-to": "Puedes invitar a otros a conectarse con {{name}} como cuidadores o crear otra cuenta para el cliente de cuidado.",
		"add-information-about-care-recipient": "Agregar información sobre el destinatario de la atención",
		"thank-you-additional-information-is-helpful": "¡Gracias!\n¡La información adicional siempre es útil!",
		"invite-family-members-to-be-connected-to": "Invita a miembros de la familia a conectarse con {{ name }}.",
		"enter-the-email-addresses-of-the-family-members-that-youd-like-to-have-connected-to": "Ingrese las direcciones de correo electrónico de los miembros de la familia con los que desea conectarse a {{ name }}",
		"organisation-requests": "Solicitudes de organización",
		"request-accepted": "Petición aceptada",
		"care-receiver-is-now-part-of-the-organisation": "El receptor de cuidados ahora es parte de la organización.",
		"request-rejected": "Solicitud rechazada",
		"temporary-access": "Acceso temporal",
		"transfer-name-to-organisation": "Transferir {{name}} a {{organisation}}"
	},
	"conversations": {
		"add-chat": "Agregar chat",
		"chats": "Chats",
		"conversation-details": "Detalles de la conversación",
		"create": "Crear",
		"create-group-chat": "Crear chat grupal",
		"create-new-chat": "Crear nuevo chat",
		"edit-chat": "Editar la conversación",
		"group-name": "Nombre del grupo",
		"group-participants": "Participantes",
		"my-chats": "Mis chats",
		"screen-title": "Mensajes",
		"sending-private-message": "Enviando un mensaje privado...",
		"type-message-here": "Escriba mensaje aquí...",
		"messages-seen-by-name-on-when": "Mensajes vistos por {{ name }} el {{ when }}",
		"report-message": "Mensaje de informe",
		"edit-info": "Para editar este chat de grupo (agregar o eliminar participantes, etc.), presione el icono del lápiz en la esquina superior derecha.",
		"access-messages": "Mensajes de acceso",
		"all-participants-in-the-chat-will-be-notified": "Todos los participantes en el chat serán notificados.",
		"to-access-the-content-of-this-chat-click-the-button-below-all-participants-in-the-chat-will-be-notified": "Para acceder al contenido de este chat, haga clic en el botón a continuación. \nTodos los participantes en el chat serán notificados.",
		"are-you-sure-to-report-this-message": "¿Estás seguro de que quieres informar este mensaje?",
		"you-will-not-see-this-message-anymore-and-we-will-review-your-report-shortly": "Ya no verá este mensaje y revisaremos su informe en breve.",
		"are-you-sure-you-want-to-delete-this-conversation": "¿Estás seguro de que deseas eliminar esta conversación?",
		"failed-to-delete-conversation": "No se pudo eliminar la conversación",
		"no-results": "Sin resultados"
	},
	"flag": "🇪🇸",
	"header": {
		"connections": "Conexiones",
		"home": "Inicio",
		"messages": "Mensajes",
		"notifications": "Notificaciones",
		"search-for-connections": "Buscar conexiones",
		"communities": "Comunidades",
		"ai": "AI"
	},
	"lock": {
		"hello": "Hola",
		"or-just-use-password-instead": "o simplemente usa tu contraseña",
		"use-fingerprint-to-login-to-your-account": "Nos preocupamos por la privacidad de nuestros clientes de cuidado. Vuelve a autenticarte para obtener acceso a Pletly Pal.",
		"cant-unlock": "¿No puedes desbloquear?"
	},
	"menu": {
		"about-app": "Acerca de la aplicación",
		"edit-profile": "Editar perfil",
		"log-out": "Cerrar sesión",
		"settings": {
			"notifications": {
				"all-notifications": "Todas las notificaciones",
				"direct-message": "Mensaje directo",
				"new-post": "Nueva publicación",
				"title": "Notificaciones",
				"new-like-on-post": "Nuevo Me Gusta en la publicación",
				"new-comment-on-post": "Nuevo comentario en la publicación."
			},
			"security": {
				"lock-description": "La aplicación Pletly Pal se bloquea automáticamente después de {{minutes}} minutos de inactividad y puede desbloquearse con TouchID, FaceID o un código de acceso.",
				"master-lock": "Bloqueo maestro",
				"title": "Seguridad"
			},
			"title": "Ajustes"
		},
		"settings-link": "Ajustes",
		"title": "Menú",
		"communities": "Comunidades",
		"switch-to-organisation-panel": "Cambiar al panel de la organización",
		"my-files": "Mis archivos"
	},
	"onboarding": {
		"add-another-post": "Agregar otro mensaje",
		"add-bio": "Agregar biografía",
		"add-connections": "Agregar conexiones",
		"add-name": "Agregar nombre",
		"add-phone": "Agregar teléfono",
		"add-phone-number": "Agregar un número de teléfono",
		"add-photo": "Agregar foto",
		"add-post": "Agregar publicación",
		"bio-card-description": "Cuéntales a otros en el ecosistema Pletly un poco sobre ti.",
		"bio-card-title": "Completa tu biografía",
		"by-adding-your-phone-number-you-are-providing-other-caregivers-an-option-to-contact-you-outside-the-pletly-ecosystem": "Al agregar tu número de teléfono, otros cuidadores tendrán la opción de contactarte fuera del ecosistema Pletly",
		"complete-your-account-setup": "Completa la configuración de tu cuenta",
		"complete-your-profile": "Completa tu perfil",
		"congratulations": "¡Felicidades!",
		"connect": "Conectar",
		"connect-card-description": "Para maximizar los beneficios de Pletly Pal, conéctate conclientes de cuidado.",
		"connect-card-title": "Conectarme con un cliente de cuidado",
		"connect-more": "Conectar más",
		"connect-with-existing-user": "Conectarme con un usuario existente",
		"create-account-for-care-receiver": "Crear cuenta para un Cliente de cuidado",
		"create-new-account-for-a-care-receiver-or-connect-to-one-if-account-is-already-created": "Crear una cuenta nueva para un cliente de cuidado o conectarme a una si su cuenta ya existe",
		"edit-bio": "Agregar biografía",
		"edit-name": "Editar nombre",
		"edit-phone": "Editar teléfono",
		"edit-photo": "Editar foto",
		"first-name": "Nombre",
		"last-name": "Apellido",
		"name-card-description": "Proporciona tu nombre y apellido. Tu identidad es importante para proporcionar una comunicación de calidad.",
		"name-card-title": "Agregar tu nombre",
		"phone-card-description": "Proporcionarnos tu número de teléfono creará una línea adicional de comunicación cuando sea necesario.",
		"phone-card-title": "Agregar número de teléfono",
		"photo-card-description": "¡Agrega una foto, porque eres hermoso/a!",
		"photo-card-title": "Agregar una foto para el perfil",
		"pletly-pal-is-the-platform-connecting-caregivers-and-facilitate-communication-with-care-receivers": "Pletly Pal conecta a los cuidadores y facilita la comunicación con los clientes de cuidado",
		"post-card-description": "Publica información o contenido multimedia que quieras compartir con otros Cuidadores de la red de tu cliente de cuidado.",
		"post-card-title": "Publicar algo",
		"profile-completed": "Perfil completado",
		"welcome-to-pletly-pal": "Bienvenido/a a Pletly Pal",
		"welcome-to-pletly-care": "Bienvenido/a a Pletly Care",
		"what-is-your-name": "¿Cuál es tu nombre?",
		"your-profile-is-complete": "¡Tu perfil está completo!"
	},
	"paywall": {
		"activate-premium": "Activar premium",
		"create-up-to-n-care-receivers-and-enjoy-unlimited-number-of-connections": "Crea hasta {{count}} clientes de cuidado y disfruta de un número ilimitado de conexiones",
		"for-the-first": "Por",
		"get-premium": "Obtener premium",
		"get-premium-and-enjoy-an-unlimited-number-of-connections": "Obtener premium y disfrutar de un número ilimitado de conexiones",
		"get-started": "Empezar",
		"maybe-later": "Quizás después",
		"periods": {
			"day_one": "día",
			"day_other": "{{count}} días",
			"month_one": "mes",
			"month_other": "{{count}} meses",
			"year_one": "año",
			"year_other": "{{count}} años"
		},
		"subscribe": "Suscribirse",
		"then": "luego",
		"try-premium": "Probar premium",
		"you-can-cancel-your-subscription-at-anytime": "Puedes cancelar la suscripción en cualquier momento"
	},
	"post": {
		"add-a-comment": "Agregar un comentario",
		"add-media": "Añadir multimedia",
		"adding-media": "Agregando medios({{ count }})...",
		"are-you-sure-to-block-author-user": "¿Estás seguro de que deseas bloquear al usuario {{user}}?",
		"are-you-sure-to-report-this-post": "¿Estás seguro de que deseas denunciar esta publicación?",
		"are-you-sure-you-want-to-delete-this-post": "¿Estás seguro de que quieres eliminar esta publicación?",
		"block-user": "Bloquear usuario",
		"book-post": {
			"new-book": "Nuevo libro"
		},
		"comment-actions": "Acciones de comentarios",
		"comments": "Comentarios",
		"delete-comment-content": "¿Estás seguro de que quieres eliminar este comentario?",
		"delete-comment-title": "¿Eliminar comentario?",
		"delete-post": "Eliminar publicación",
		"editing-comment": "Editando comentario",
		"welcome-post": {
			"get-to-know-care-receivers": "Conoce a tus clientes de cuidado",
			"information-library": "Biblioteca de información",
			"pletly-pal-offers-custom-made-biography": "Pletly ofrece una biografía personalizada de todos tus clientes de cuidado.",
			"swipe-left-to-learn-more": "Desliza hacia la izquierda para conocer más sobre Pletly.",
			"you-can-easily-structure-necessary-information": "Puedes estructurar fácilmente la información necesaria sobre un cliente de cuidado. Esto podría incluir videos de lenguaje de señas o ejercicios físicos.",
			"welcome-to-pletly": "¡Bienvenido/a a Pletly!",
			"content": "¡Gracias por unirte a Pletly! \nNos complace darle la bienvenida a nuestra plataforma, donde nos esforzamos por mejorar la calidad de la atención y mejorar vidas fomentando conexiones más estrechas dentro del círculo de atención y promoviendo la atención centrada en la persona.",
			"social-feed-content": "Obtenga información significativa sobre la vida diaria del destinatario de la atención a través de nuestras redes sociales, manteniendo su privacidad.",
			"social-feed-title": "Feed social privado y seguro"
		},
		"likes": "Me gusta",
		"new": {
			"add-text": "Agregar texto",
			"add-users": "Agregar usuarios",
			"and-others_one": "y {{count}} más",
			"and-others_other": "y {{count}} más",
			"create-new-post": "Crear una publicación",
			"edit-post": "Editar publicación",
			"permission-to-access-camera-roll-is-required": "Se requiere permiso para acceder al álbum de la cámara",
			"post-privacy": "Privacidad de la publicación",
			"publication-settings": "Ajustes de publicación",
			"publish": "Publicar",
			"save-settings": "Guardar ajustes",
			"saving-post": "Publicando",
			"your-post-is-being-published": "Tu publicación se está publicando...",
			"your-care-recipients": "Los destinatarios de su atención",
			"search-care-recipients": "Buscar destinatarios de atención",
			"errors": {
				"content-media-required": "Contenido de texto o medios requeridos",
				"privacy": "Seleccione al menos un destinatario de atención"
			},
			"info": {
				"post-submitted-for-review": "Tu publicación ha sido enviada para revisión.",
				"post-edited-and-resubmited-for-review": "La publicación ha sido editada y enviada nuevamente para su revisión."
			},
			"your-teams": "Tus equipos",
			"organisation": "Organización",
			"all-employees": "Todos los empleados",
			"select": "Seleccionar",
			"team": "Equipo ({{ count }})",
			"blur-faces": {
				"previous-photo": "Foto anterior",
				"next-photo": "siguiente foto",
				"blur-faces-in-photos": "Desenfocar rostros en fotos ({{ count }})",
				"add-a-photo-of-the-care-recipients-face-that-is-not-to-be-blured-out": "Agregue una foto del rostro de la persona atendida que no deba borrarse.",
				"care-receiver-reference-photo": "Foto de referencia del receptor de cuidados",
				"blur-all": "Desenfocar todo"
			},
			"schedule-for-later": "Programar para más tarde",
			"to-be-published": "Fecha de publicación",
			"date": "Fecha",
			"time": "Tiempo",
			"show-scheduled-posts": "Ver todas las publicaciones programadas",
			"restrict-visibility-checkbox": "Restringir la visibilidad solo a cuidadores profesionales"
		},
		"pin-post": "Anclar publicación",
		"pinned-post": "Publicación anclada",
		"post": "Publicación",
		"report-post": "Denunciar publicación",
		"report-sent": "Denuncia enviada",
		"see-all-comments": "Ver todos los comentarios",
		"selected-users": "Usuarios seleccionados",
		"this-will-hide-it-for-you-and-report-the-post-to-the-moderators": "Esto lo ocultar para ti y reportará la publicación a los moderadores.",
		"unpin-post": "Desanclar publicación",
		"user-blocked": "Usuario bloqueado",
		"users-publications": "publicaciones del usuario",
		"we-will-review-your-report-shortly": "Revisaremos tu denuncia en breve",
		"you-will-not-see-content-from-this-user-anymore": "Ya no verás contenido de este usuario.",
		"post-deleted": "Publicación eliminada",
		"review": {
			"approve": "Aprobar",
			"reject": "Rechazar",
			"confirm-reject-modal": {
				"title": "¿Estás seguro de que quieres rechazar la publicación de {{authorName}}?",
				"content": "Proporcione el motivo del rechazo de la publicación.",
				"reason-field-label": "Razón",
				"reason-field-placeholder": "Ingrese aquí el motivo del rechazo"
			},
			"posts-to-review-screen": {
				"subtitle": "Publicaciones esperando ser aprobadas",
				"title": "Aprobación de publicaciones"
			},
			"status": {
				"pending": "Pendiente",
				"rejected": "Rechazado",
				"approved": "Aprobado"
			},
			"review-submitted-successfully": "Revisión enviada exitosamente",
			"posts-submitted-screen": {
				"subtitle": "Publicaciones en espera de ser aprobadas.",
				"title": "Aprobación de publicaciones",
				"reason": "Razón"
			},
			"discard": "Desechar",
			"edit": "Editar",
			"menu": {
				"posts-under-review": "Publicaciones bajo revisión",
				"posts-to-review": "Publicaciones para revisar"
			}
		},
		"share": {
			"share": "Compartir",
			"share-post": "Compartir post",
			"shared-post": "Publicación compartida",
			"shared-with": "Compartido con {{ name }}",
			"post-has-been-sent-in-a-chat-message": "La publicación ha sido enviada en un mensaje de chat.",
			"someone-shared-post": "{{authorName }} ha compartido algo importante contigo. \nHaga clic aquí para comprobarlo."
		},
		"adding-media_zero": "Agregando medios...",
		"admin": "Administración",
		"errors": {
			"forbidden": {
				"title": "Acceso denegado: acceso no autorizado",
				"message": "\nParece que no tiene permiso para ver este contenido porque no está conectado con el destinatario de la atención correspondiente. \nEsta restricción existe para proteger la privacidad de la información confidencial.\n \nSi cree que se trata de un error, verifique sus conexiones o comuníquese con la persona que compartió la publicación para obtener más ayuda."
			}
		},
		"blur-faces": "Caras borrosas",
		"accept": "Aceptar",
		"add-file": "Agregar archivo",
		"delete-file": "Eliminar archivo",
		"are-you-sure-you-want-to-delete": "¿Estás seguro de que quieres eliminar {{ name }}?",
		"file-deleted": "Archivo eliminado",
		"file-has-been-deleted-successfully": "{{ name }} se ha eliminado con éxito.",
		"filters": {
			"modal": {
				"title": "Filtros",
				"published-in": {
					"custom-label": "Período personalizado",
					"custom-placeholder": "Seleccione el período personalizado",
					"label": "Fecha de publicación",
					"option-days_one": "Último día",
					"option-days_other": "Últimos {{count}} días",
					"option-all-time": "Todo el tiempo"
				},
				"care-recipients": {
					"label": "Receptores de atención",
					"no-care-recipients-to-select": "No hay destinatarios para seleccionar",
					"everyone": "Todos",
					"selected-only": "Solo seleccionado"
				},
				"tags": {
					"label": "Etiquetas",
					"no-tags-selected": "No hay etiquetas seleccionadas",
					"available-tags": "Etiquetas disponibles",
					"no-tags-available": "No hay etiquetas disponibles"
				}
			},
			"btn-show": "Mostrar filtros",
			"btn-reset": "Restablecer filtros"
		},
		"scheduled-posts": "Publicaciones programadas",
		"no-posts-scheduled": "No hay publicaciones programadas",
		"publication-error-warning": "Esta publicación no se pudo publicar. \nPor favor revisa tu publicación y vuelve a intentarlo."
	},
	"profile": {
		"about": "Acerca de",
		"about-me": "Acerca de mí",
		"add-folder-icon": "Agregar un icono de carpeta",
		"add-information": "Agregar información",
		"add-information-icon": "Agregar icono de información",
		"add-post-to-information": "Agregar una publicación a la información",
		"are-you-sure-remove-folder-name": "¿Estás seguro de que quieres eliminar la carpeta de información {{name}}?",
		"are-you-sure-remove-information-name": "¿Estás seguro de que quieres eliminar la información {{name}}?",
		"are-you-sure-you-want-to-delete-profile-username-account-forever": "¿Estás seguro de que deseas eliminar la cuenta de {{username}} para siempre?",
		"change-password": "Cambiar contraseña",
		"connections": "Conexiones",
		"create-a-folder": "Crear una carpeta",
		"create-information": "Crear información",
		"create-subfolder": "Crear subcarpeta",
		"critical": "Crítico",
		"delete-account": "Eliminar cuenta",
		"delete-caregiver-confirm-content": "¿Estás seguro de que quieres eliminar la conexión de {{careGiverName}} con {{careReceiverName}}?",
		"delete-caregiver-confirm-title": "Desconectar a {{careGiverName}}",
		"delete-profile-username-account": "Eliminar cuenta de {{username}}",
		"edit-folder": "Editar carpeta",
		"edit-folder-icon": "Editar icono de carpeta",
		"edit-information": "Editar información",
		"edit-information-folder": "Editar carpeta de información",
		"edit-information-icon": "Editar icono de información",
		"edit-profile": "Editar perfil",
		"error-firstname-lastname-empty": "El nombre y apellido no pueden estar vacíos",
		"error-username-empty": "El campo de nombre de usuario no puede estar vacío",
		"feed": "Feed",
		"fill-information": "Completar información",
		"folder-name": "Nombre de la carpeta",
		"improve-your-security-with-a-strong-password": "Mejora tu seguridad con una contraseña fuerte.",
		"information": "Información",
		"information-name": "Nombre de la información",
		"information-not-completed": "Este cliente de cuidado tiene información incompleta",
		"my-profile": "Mi perfil",
		"negative": "Desafíos",
		"new-information": "Información nueva",
		"new-information-folder": "Carpeta nueva de información",
		"new-password": "Contraseña nueva",
		"not-authorized-to-view-profile": "No estás autorizado para ver este perfil.",
		"old-password": "Contraseña anterior",
		"password-changed": "La contraseña ha sido cambiada",
		"passwords-do-not-match": "Las contraseñas no coinciden",
		"positive": "Preferencias",
		"remove-folder": "Eliminar carpeta",
		"remove-information": "Eliminar información",
		"repeat-new-password": "Repetir nueva contraseña",
		"restricted-access": "Acceso restringido",
		"restricted-access-description": "Cuando está desactivado, el usuario podrá añadir publicaciones y comentarios, dar 'me gusta', editar y eliminar los existentes.",
		"save-information": "Guardar información",
		"saving-new-password": "Guardando contraseña nueva...",
		"saving-profile-photo": "Guardando foto para el perfil...",
		"saving-user-information": "Guardando información del usuario...",
		"select-icon": "Seleccionar ícono",
		"send-message": "Chatear",
		"show-activity": "Mostrar actividad",
		"there-are-no-posts-in-information": "No hay publicaciones en la información.",
		"there-is-no-information-yet": "Todavía no hay información.",
		"this-action-cannot-be-undone": "Esta acción no puede deshacerse",
		"would-you-like-to-invite-as-caregiver-for": "¿Le gustaría invitar a {{careGiverName}} a convertirse en cuidador de {{careReceiverName}}?",
		"invite": "Invitar",
		"invitation-sent": "La invitación ha sido enviada.",
		"revoke": "Revocar",
		"revoke-invitation-confirm-title": "¿Revocar invitación?",
		"invitation-revoked": "La invitación ha sido revocada.",
		"profile-saved": "El perfil ha sido guardado.",
		"invite-to-become-caregiver": "Invitar a convertirse en cuidador",
		"new-password-must-be-different-from-the-old-one": "La nueva contraseña debe ser diferente a la anterior.",
		"invalid-password": "Contraseña invalida",
		"folder-access": {
			"access": "Acceso",
			"options": {
				"description-everyone": "Cada cuidador conectado tendrá acceso a esta",
				"description-everyone-in-organisation": "Todos los cuidadores de la organización {{ organisationName }} tendrán acceso a esta",
				"description-individual-caregivers": "Solo los cuidadores seleccionados tendrán acceso a esta",
				"everyone": "Todos",
				"everyone-in-organisation": "Todos en la organización",
				"individual-caregivers": "Cuidadores individuales"
			},
			"set-access": "Establecer acceso",
			"caregiver-list": "Lista de cuidadores",
			"no-caregivers-to-select": "No hay cuidadores para seleccionar",
			"access-settings-saved": "Configuración de acceso guardada",
			"target-information": "información",
			"target-folder": "carpeta",
			"access-to-the": "Acceso al"
		},
		"invite-caregivers": "Invitar a los cuidadores",
		"no-user-posts": "No hay publicaciones de usuarios",
		"create-first-post-on-user-feed-to-get-started": "Cree la primera publicación en el feed del usuario para comenzar",
		"add-new-post": "Agregar nueva publicación",
		"access-to-profile-expires": "El acceso a este perfil caduca",
		"no-care-recipients-available": "No hay beneficiarios de atención disponibles para seleccionar",
		"files": "Archivos",
		"files-table": {
			"name": "Nombre",
			"creator": "Creador",
			"created-at": "Creado a",
			"connected-care-recipients": "Destinatarios de atención conectada"
		}
	},
	"validations": {
		"error": "Error"
	},
	"verification": {
		"an-email-has-been-sent-to": "Se ha enviado un correo electrónico a",
		"please-click-on-link-to-verify-your-email-address": "Por favor, haga clic en el enlace para verificar su dirección de correo electrónico",
		"resend-email": "Reenviar correo electrónico",
		"sent-please-check-your-email": "Enviado, por favor revise su correo electrónico",
		"verify-email": "Verificar correo electrónico",
		"your-email-has-been-successfully-verified": "Su correo electrónico ha sido verificado exitosamente."
	},
	"notifications": {
		"there-are-no-notifications": "No hay notificaciones.",
		"no-new-updates-right-now-youll-be-the-first-to-know-when-theres-something-new": "No hay nuevas actualizaciones en este momento. \nSerás el primero en enterarte cuando haya algo nuevo."
	},
	"community": {
		"add-post-to-the-community": "Agregar publicación a la comunidad...",
		"join-owner": "Dueño",
		"joined": "Unido",
		"add-description-here": "Añade una descripción aquí...",
		"invite": "Invitar",
		"explore": "Explorar",
		"your-communities": "Tus comunidades",
		"community-you-belong-to": "Comunidad a la que perteneces",
		"invitations": "Invitaciones",
		"community-you-manage": "Comunidad que administras",
		"add-name-here": "Añade nombre aquí...",
		"admins": "Administradores",
		"are-you-sure-you-want-to-make-this-group-privacy": "¿Estás seguro de que quieres que este grupo tenga {{privacy}}?",
		"change-group-visibility": "Cambiar la visibilidad del grupo",
		"communities": "Comunidades",
		"community-description": "Descripción de la comunidad",
		"community-members": "Miembros de la comunidad",
		"community-name": "Nombre de la comunidad",
		"create-new-community": "Crear nueva comunidad",
		"create-new-post": "Crear nueva publicación",
		"find-users-to-add": "Buscar usuarios para agregar",
		"invite-to-community": "invitar a la comunidad",
		"invite-users": "Invitar usuarios",
		"join": "Unirse",
		"leave": "Dejar",
		"make": "Hacer",
		"manage-members": "Administrar miembros",
		"members": "miembros",
		"pick-privacy-setting": "Establecer configuración de privacidad",
		"privacy-settings": "La configuración de privacidad",
		"private": "Privado",
		"public": "Público",
		"group-visibility-updated": "Visibilidad del grupo actualizada",
		"join-request-sent": "Solicitud de unión enviada",
		"your-request-has-been-sent-to-the-community-owner": "Su solicitud ha sido enviada al propietario de la comunidad.",
		"leave-community": "Salir de la comunidad",
		"delete-community": "Eliminar comunidad",
		"are-you-sure-you-want-to-delete": "¿Estás seguro de que deseas eliminar {{ name }}?",
		"invites-sent": "Invitaciones enviadas",
		"invited": "Invitado",
		"admin-removed": "Administrador eliminado",
		"are-you-sure-you-want-to-leave-this-community": "¿Estás seguro de que quieres abandonar esta comunidad?",
		"invite-removed": "Invitación eliminada",
		"admin-added": "Se ha agregado administrador",
		"are-you-sure-you-want-to-remove-member": "¿Estás seguro de que deseas eliminar {{name}}?",
		"member-removed": "El miembro ha sido eliminado.",
		"remove-member": "Eliminar miembro"
	},
	"summarization": {
		"from-date-until-date": "desde {{fromDate}} hasta {{toDate}}",
		"generate-summary": "Generar resumen de publicaciones",
		"generating-summary": "Generando resumen...",
		"no-posts-to-summarize": "No hay publicaciones para resumir para este período.",
		"posts-summary": "Resumen de publicaciones",
		"select-dates": "Seleccionar fechas",
		"select-from-date": "Seleccionar desde fecha",
		"select-to-date": "Seleccionar hasta la fecha",
		"summarize-posts": "Resumir publicaciones",
		"warning-text": "El contenido generado por IA puede contener errores. Usa tu criterio y verifica los datos importantes.",
		"key-insights": "Puntos clave",
		"suggestions": "Sugerencias",
		"mood": "Estado de ánimo"
	},
	"zod": {
		"only-letters-numbers-and-underscores-are-allowed": "Sólo se permiten letras, números y guiones bajos."
	},
	"no-information-folders": "Sin carpetas de información",
	"create-your-first-folder-to-get-started": "Crea tu primera carpeta para comenzar",
	"undo": "Deshacer",
	"edit-profile-form": {
		"receive-summary-notification-emails": "Recibir correos electrónicos de notificación resumida"
	},
	"upload-new-file": "Subir un archivo nuevo"
}
